import script from "./btn.vue?vue&type=script&lang=ts&setup=true"
export * from "./btn.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__